
define('text!fusion/ui/controls/fusion-list-item.html',[],function () { return '<li>\r\n    <!-- ko transclude: \'\' -->\r\n    <!-- /ko -->\r\n</li>\r\n';});

